import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface AuthErrorPageProps {
  error: unknown;
}

// Shown when /me fails. The Workers API returns 401 when the Cloudflare
// Access cookie is missing or expired; redirect the user through Access
// to refresh the cookie (Cloudflare's CDN handles the round-trip and
// drops the user back here afterwards).
export function AuthErrorPage({ error }: AuthErrorPageProps) {
  const message = error instanceof Error ? error.message : 'Authentication failed';
  return (
    <div className="flex h-screen items-center justify-center bg-muted/40 p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="flex flex-col items-center gap-3">
          <img src="/logo-mark.svg" alt="TrackerCop" className="h-12 w-12" />
          <CardTitle>Sign in required</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4 text-sm">
          <p className="text-muted-foreground">{message}</p>
          <Button onClick={() => (window.location.href = '/cdn-cgi/access/login')}>
            Continue to sign-in
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
